import { Endpoints } from "../constants/endpoint";

const buildQuery = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
};

export const GetAllTranscriptionTags = async (params = {}) => {
  try {
    const res = await fetch(
      `${Endpoints.transcriptionTags}${buildQuery(params)}`
    );
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};

export const CreateTranscriptionTag = async (payload) => {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify(payload),
  };
  try {
    const res = await fetch(Endpoints.transcriptionTags, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};

export const DeleteTranscriptionTag = async (id) => {
  const options = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
  };
  try {
    const res = await fetch(Endpoints.transcriptionTags + id, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};
